import { Link } from "react-router-dom"
import * as React from "react"
import { Container } from 'react-bootstrap'

import { Contact } from '../components/contact'
import { Business } from '../components/index/business'
import { Information } from "../components/index/information"
import { Map } from '../components/index/map'
import { Technology } from '../components/index/technology'
import { Layout } from "../components/layout" 
import { useTranslation } from "react-i18next"


export const IndexPage = () => {
  const { t } = useTranslation("translations", { keyPrefix: "INDEX" })

  return (
    <Layout>
      <Container>
        <article className="my-5 text-center">
          <div className="mb-4">
            <h1 className="mb-0">ABOUT</h1>
            <small>{t("ABOUT.SUBTITLE")}</small>
          </div>
          <p>{t("ABOUT.DESC_1")}</p>
          <p>{t("ABOUT.DESC_2")}</p>
          <Link to="/company-info">
            <small>{t("ABOUT.COMPANY_INFO")} &gt;</small>
          </Link>
        </article>
      </Container>
      <Business />
      <Technology />
      <Map />
      <Information />
      <Contact />
    </Layout>
  )
}